import { Grid, Typography } from "@mui/material";
import NumberFormats from "components/NumberFormats";

import Table from "components/Table";
import WrapperAmount from "./Component/WrapperAmount";
import { useSelector } from "react-redux";

const headers = [
  {
    name: "Coin",
    key: "coin",
  },
  {
    name: "Type",
    key: "type",
  },
  {
    name: "Amount",
    key: "amount",
  },
  {
    name: "Date & Time",
    key: "date",
  },
];

function TableBasketHistory() {
  const basketHistoryList = useSelector((state) => state.wallet.basketHistoryList)

  const formattedDataList = basketHistoryList?.data?.map((data) => {
    return {
      coin: <WrapperAmount data={data} />,
      type: (
        <Typography variant="h5" color="text.main" dir="rtl">
          {data?.type}
        </Typography>
      ),
      amount: (
        <Typography variant="h5" color="text.main">
          <NumberFormats value={data?.amount} />
        </Typography>
      ),
      date: (
        <Typography variant="h5" color="text.main">
          {data?.date} {data?.time}
        </Typography>
      ),
    };
  });

  return (
    <>
      <Grid item xs={12}>
        <Table headers={headers} items={formattedDataList} hideBorders={true} />
      </Grid>
    </>
  );
}
export default TableBasketHistory;
